export const staffCaregiverHiringRoutePrefixes = ["/biz/staff"];
